import { Text, Stack } from '@mantine/core';
import styles from './paginaNoEncontrada.module.css';

export default function PaginaNoEncontrada() {
  return (
    <div className={styles.wrapper}>
      <Stack align="center" gap="xs" className={styles.content}>
        <img
          src="/robot.png"
          alt="Página no encontrada"
          className={styles.imagen}
        />
        <Text className={styles.descripcion}>
          La página que estás buscando no existe o ha sido movida.
        </Text>
      </Stack>
    </div>
  );
}
